import { Button, Flex } from '@rocket/ui';

import { BaseDialog } from '../BaseDialog/BaseDialog';

export interface OpenExportDialogProps {
  open: boolean;
  handleExport: () => void;
  handleClose: () => void;
}

const OpenExportDialog = ({ open, handleExport, handleClose }: OpenExportDialogProps) => (
  <BaseDialog
    open={open}
    handleClose={handleClose}
    showContractIcon
    purpose="export"
    title="Export Contract"
    subtitle="Exporting a document signals to BlackBoiler that you are sending the contract back to the counter party. We use this opportunity to update our machine learning editing engine, so that in the future we can provide you better edits."
  >
    <Flex width="100%" gap="16px">
      <Button variant="outline" colorPalette="gray" flex="1" onClick={handleClose}>
        Cancel
      </Button>
      <Button variant="solid" colorPalette="gray" flex="1" onClick={handleExport}>
        Export
      </Button>
    </Flex>
  </BaseDialog>
);

export default OpenExportDialog;
